<template>
  <div :class="{ 'has-crossprice': hasCrossPrice || (!!currentOffer && item != null && item.item.id == currentVariation.item.id && isActiveByStock), 'is-specialoffer': !!currentOffer && item != null && item.item.id == currentVariation.item.id && isActiveByStock }">
    <template v-if="!!currentOffer && item != null && item.item.id == currentVariation.item.id && isActiveByStock">
      <div class="offer-countdown">
        <div
          v-if="!!duration"
          class="live-shopping-countdown-heading"
        >
          {{ $translate("Ceres::Template.liveShoppingOfferEndsIn") }}
        </div>
        <div
          v-if="!!duration"
          class="live-shopping-countdown-thread-container"
        >
          <div class="live-shopping-countdown-thread">
            <div class="live-shopping-countdown-thread-number offer-hours">
              {{ duration.hours }}
            </div>
            <div class="small">
              {{ $translate("Ceres::Template.liveShoppingHours") }}
            </div>
          </div>
          <div class="live-shopping-countdown-thread">
            <div class="live-shopping-countdown-thread-number offer-minutes">
              {{ duration.minutes }}
            </div>
            <div class="small">
              {{ $translate("Ceres::Template.liveShoppingMinutes") }}
            </div>
          </div>
          <div class="live-shopping-countdown-thread">
            <div class="live-shopping-countdown-thread-number offer-seconds">
              {{ duration.seconds }}
            </div>
            <div class="small">
              {{ $translate("Ceres::Template.liveShoppingSeconds") }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <div>
      <div
        v-if="showCrossPrice && hasCrossPrice && currentVariation.prices.rrp && currentVariation.prices.rrp.unitPrice.value > 0"
        class="crossprice"
      >
        <span class="text-muted small text-appearance">{{ $translate("Ecomsilio::Template.oldPrice") }}: <del>{{ currentVariation.prices.rrp.unitPrice.formatted }}</del></span>
      </div>
      <div
        v-else-if="showCrossPrice && hasSpecialOffer"
        class="crossprice"
      >
        <span class="text-muted small text-appearance"> {{ $translate("Ecomsilio::Template.oldPrice") }}: <del>{{ currentVariation.prices.default.unitPrice.formatted }}</del><template v-if="!isNaN(itemPriceRebatePercentage) && itemPriceRebatePercentage > 0"> (- {{ itemPriceRebatePercentage }} %)</template></span>
      </div>
      <span
        class="price h1"
        :class="{ 'is-special-offer': hasSpecialOffer }"
      >
        <template v-if="showDynamicPrice">{{ $translate("Ceres::Template.dynamicVariationPrice",{price: $options.filters.currency(variationTotalPrice, currentVariation.prices.default.currency)}) }}</template>
        <template v-else>{{ variationTotalPrice | currency(currentVariation.prices.default.currency) }}</template><sup>*</sup>
      </span>
      <div
        v-if="currentVariation.prices.default.lowestPrice.value && showCrossPrice && hasCrossPrice"
        class="lowest-price text-muted mb-3"
      >
        <div v-html="$translate('Ceres::Template.singleItemLowestPrice', {'price': currentVariation.prices.default.lowestPrice.formatted})" />
      </div>
      <div
        v-if="currentVariation.unit"
        class="base-price text-muted my-3"
        :class="{ 'is-single-piece': currentVariation.unit && currentVariation.unit.content === 1 && currentVariation.unit.unitOfMeasurement === 'C62' }"
      >
        <div>{{ $translate("Ceres::Template.singleItemContent") }}: <span>{{ currentVariation.unit.content | numberFormat }} </span><span>{{ currentVariation.unit.names.name }}</span></div>
        <div v-if="currentVariation.variation.mayShowUnitPrice">
          {{ $translate("Ceres::Template.singleItemUnitPrice") }}:
          <span class="base-price-value">{{ variationGraduatedPrice.basePrice | specialOffer(currentVariation.prices, "basePrice") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "BwItemPrice",
    inject: { itemId: { default: null } },
    props: {
        showCrossPrice: { type: Boolean, default: true },
        liveShoppingId: {
            type: Number,
            required: true,
            validator: value =>
            {
                return value % 1 === 0 && value >= 1 && value <= 10
            }
        }
    },
    data ()
    {
        return { currentInterval: null, duration: null }
    },
    computed: {
        currentVariation ()
        {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },
        hasCrossPrice ()
        {
            const hasRrpPrice = !!this.currentVariation.prices.rrp &&
          this.currentVariation.prices.rrp.unitPrice.value > this.currentVariation.prices.default.unitPrice.value
            const hasBeforePrice = this.hasSpecialOffer &&
          !!this.currentVariation.prices.default &&
          this.currentVariation.prices.default.unitPrice.value > this.currentVariation.prices.specialOffer.unitPrice.value

            return hasRrpPrice || hasBeforePrice
        },
        hasSpecialOffer ()
        {
            return !!this.currentVariation.prices.specialOffer
        },
        variationGraduatedPrice ()
        {
            return this.$store.getters[`${this.itemId}/variationGraduatedPrice`]
        },
        variationTotalPrice ()
        {
            return this.$store.getters[`${this.itemId}/variationTotalPrice`]
        },
        showDynamicPrice ()
        {
            const state = this.$store.state.items[this.itemId]

            return App.config.item.showPleaseSelect && App.isCheapestSorting &&
          (state.variationSelect && !state.variationSelect.isVariationSelected) &&
          (state.pleaseSelectVariationId === this.currentVariation.variation.id ||
              state.pleaseSelectVariationId === 0)
        },
        currentOffer ()
        {
            return this.$store.state.liveShopping.liveShoppingOffers[this._uid]
        },
        item ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                return this.currentOffer.item
            }
            return null
        },
        currentLiveshopping ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                return this.currentOffer.liveShopping
            }
            return null
        },
        isActiveByStock ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                if (!(this.currentLiveshopping.quantitySold < this.currentLiveshopping.quantityMax))
                {
                    return this.currentOffer.item.item.salableVariationCount > 0
                }
                else
                {
                    return true
                }
            }
            return false
        },
        prices ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                const itemPrices = this.currentOffer.item.prices
                const prices = {
                    price: itemPrices.default,
                    rrp: itemPrices.rrp,
                    isRrpDefaultPrice: false
                }

                if (!(itemPrices.specialOffer === null || typeof itemPrices.specialOffer === typeof void 0))
                {
                    prices.price = itemPrices.specialOffer
                    prices.rrp = itemPrices.default || itemPrices.rrp
                    prices.isRrpDefaultPrice = !!itemPrices.default
                }
                return prices
            }
            return false
        },
        itemPriceRebatePercentage ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                const specialOfferPrice = this.prices.price.price.value
                const defaultPrice = (this.prices.rrp && this.prices.rrp.price.value) || 0

                let percentage = 100 - specialOfferPrice / defaultPrice * 100

                percentage = percentage.toFixed(App.config.item.storeSpecial)
                percentage = percentage.replace(".", App.decimalSeparator)
                return percentage
            }
            return null
        },
        durationinDays ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                return Math.ceil((this.currentLiveshopping.toTime - (new Date().getTime() / 1000)) / (60 * 60 * 24))
            }
            return null
        }
    },
    watch: {
        currentLiveshopping ()
        {
            this.initializeDataAndTimer()
        }
    },
    created: function ()
    {
        this.$store.dispatch("retrieveLiveShoppingOffer", { liveShoppingId: this.liveShoppingId, sorting: this.sorting, uid: this._uid })
    },
    methods: {
        initializeDataAndTimer ()
        {
            clearInterval(this.currentInterval)
            this.calculations()
            this.currentInterval = setInterval(() =>
            {
                this.calculations()
            }, 1000)
        },
        calculations ()
        {
            let timeLeft = 0

            if (this.currentLiveshopping.toTime - (new Date().getTime() / 1000) <= 0)
            {
                clearInterval(this.currentInterval)
            }
            else
            {
                timeLeft = this.currentLiveshopping.toTime - (new Date().getTime() / 1000)
            }
            this.duration = this.getDuration(timeLeft)
        },
        getDuration (seconds)
        {
            let hours = Math.floor(seconds / (60 * 60))

            if (hours / 10 < 1)
            {
                hours = "0" + hours
            }
            seconds = seconds - (hours * 60 * 60)
            let minutes = Math.floor(seconds / 60)

            if (minutes / 10 < 1)
            {
                minutes = "0" + minutes
            }
            seconds = Math.floor(seconds - (minutes * 60))
            if (seconds / 10 < 1)
            {
                seconds = "0" + seconds
            }
            return { hours, minutes, seconds }
        }
    }
}
</script>
